/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_IncreaseInputs */



/**
* | output |
* | --- |
* | "Increase" |
*
* @param {Common_IncreaseInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const common_increase = /** @type {((inputs?: Common_IncreaseInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_IncreaseInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Augmenter")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aumentar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Aumentar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aumenta")
	return /** @type {LocalizedString} */ ("Increase")
});